import { NgClass, NgTemplateOutlet } from '@angular/common';
import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { DsButton } from '@frontend/ui/button';
import {
    ClaimsService,
    DynamicHtmlDirective,
    HtmlNode,
    LoadingIndicatorHandler,
    LoadingIndicatorService,
    LoginNavigationService,
    MediaQueryService,
    MessageLifetime,
    MessageQueueService,
    MessageType,
    NativeAppService,
    NavigationService,
    PlainLinkComponent,
    TrackingService,
    UserService,
    WindowRef,
} from '@frontend/vanilla/core';
import { MessagePanelComponent } from '@frontend/vanilla/features/message-panel';
import { PopperContentComponent } from '@frontend/vanilla/features/popper';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { DarkModeService } from '@frontend/vanilla/shared/dark-mode';
import { NgxFloatUiDirective } from 'ngx-float-ui';
import { Observable, of } from 'rxjs';

import { ZendeskClientConfig } from '../../client-config/client-config.models';
import { PortalMediaQueryService } from '../../common/portal-merdia-query-service';
import { NewAccountMenuService } from '../../services/account-menu-v2.service';
import { PortalNavigationService } from '../../services/portal-navigation.service';
import { CommonMethodsService } from '../../tracking/common-methods-service';
import { ZendeskLiveChatComponent } from '../../zendesk-live-chat/zendesk-live-chat.component';
import { ContactResourceService } from '../contact-resource.service';
import { HelpAndContactData, LinkTemplateItem, contactOptionObject } from '../contact.models';
import { PortalTrackingService } from './../../tracking/tracking-resource.service';
import { EventNameConst, TrackingEvent } from './../../tracking/tracking.model';
import { PhoneOptionComponent } from './phone-option.component';

@Component({
    selector: 'pt-contact-options',
    templateUrl: 'contact-options.component.html',
    imports: [
        NgClass,
        NgTemplateOutlet,
        ZendeskLiveChatComponent,
        NgxFloatUiDirective,
        PopperContentComponent,
        DynamicHtmlDirective,
        PlainLinkComponent,
        MessagePanelComponent,
        TrustAsHtmlPipe,
        DsButton,
    ],
})
export class ContactOptionsComponent implements OnInit, AfterViewChecked {
    @Input() contactData: any;
    @Input() selectedCategory: any;
    @Input() helpAndContactData: HelpAndContactData;
    @Input() optionsScreen: boolean;
    @Input() faqLink: LinkTemplateItem;
    @Input() showEmail: boolean;
    @Input() showPhone: boolean;
    @Input() desktopContactUs: boolean;
    @Output() onEmailSelected: EventEmitter<boolean> = new EventEmitter();
    @Output() onEmailScreenLoad: EventEmitter<any> = new EventEmitter();
    @Output() onPhoneSelected: EventEmitter<any> = new EventEmitter();
    @Input() currentSelectedSubCategory: any;
    @Input() twitterLink: LinkTemplateItem;
    @Input() HccArticle: string;
    @Input() HccCategory: string;
    @Output() onclick: EventEmitter<any> = new EventEmitter();
    enabledContactOptions: any[] = [];
    disabledContactOptions: any[] = [];
    contactOptionsData: any = [];
    contentHelp = 'Help & Contact';
    isKycVerified: boolean = false;
    isDocumentPending: boolean = false;
    liveChatenabled: boolean;
    isLoggedIn: boolean = false;
    uploadDocumentContent: string;
    uploadDocumentTooltip: string;
    uploadDocumentLink: string;
    uploadDocumentName: string;
    csMsg: any;
    csLink: string = '';
    isPopupVisible: boolean;
    phoneList: any[] = [];
    isphoneOptionAvailable: boolean;
    livechatWaTrigger: boolean = false;
    phoneWaTrigger: boolean = false;
    bannerTextPhase2: any;
    isPhoneDependentOnAgent: boolean;
    v2NavEnabled: boolean = false;
    v2NavEnabledPreLogin: boolean = false;
    noOfContactOptions: number;
    sitecoreControlForOptionsEnabled: boolean = false;
    recommenededOptions: string[] = [];
    allowedCPKeywords: string[] = [];
    enableCORPhoneNumbers: string[] = [];
    phase3: boolean;
    phase2: boolean;
    message: any;
    ZendeskliveChat: string = 'Live Chat';
    optionAlreadyUpdated: { [id: string]: boolean } = {
        CHAT: false,
        PHONE: false,
        EMAIL: false,
        FAQ: false,
        TWITTER: false,
        FACEBOOK: false,
        INSTAGRAM: false,
    };
    zendeskChatEnabled: boolean;
    isMobile: boolean = false;
    facebookLink: LinkTemplateItem | null;
    pqrsLink: LinkTemplateItem | null;
    loadingIndicationDisabled: boolean = false;
    private loadingIndicatorHandler: LoadingIndicatorHandler;
    darkModeEnabled: boolean = false;
    deepLinkingEnabled = false;
    showchathistory: boolean = false;
    navigationSource: string;
    isCustomSource: boolean = false;
    instagram: LinkTemplateItem | null;
    isNative: boolean = false;
    nativeTwitterLink: string;
    nativeFaceBookLink: string;
    nativeInstagramLink: string;
    isXsDevice: boolean;
    isGtXsDevice: boolean;
    constructor(
        private contactResourceService: ContactResourceService,
        private navigationService: NavigationService,
        private loginNavigationService: LoginNavigationService,
        private user: UserService,
        private htmlNode: HtmlNode,
        protected dialog: MatDialog,
        private windowRef: WindowRef,
        private tracking: TrackingService,
        private nativeApplicationService: NativeAppService,
        public newAccountMenuService: NewAccountMenuService,
        private messageQueue: MessageQueueService,
        public mediaQueryService: MediaQueryService,
        private zendeskClientConfig: ZendeskClientConfig,
        private portalTrackingService: PortalTrackingService,
        private loadingIndicator: LoadingIndicatorService,
        private darkModeService: DarkModeService,
        private changeDetectorRef: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private claimsService: ClaimsService,
        private commonMethodService: CommonMethodsService,
        private portalMediaQueryService: PortalMediaQueryService,
        private portalNavigation: PortalNavigationService,
    ) {}

    ngOnInit() {
        this.commonMethodService.hideLoader();
        this.commonMethodService.loadSkeleton('HCCContactSkeleton', 'hcc-skeleton-contact');
        if (this.contactData.isLoadingIndicatorEnabled && this.contactData.enableHelpAndContactPhase3) {
            this.loadingIndicatorHandler = this.loadingIndicator.start({ delay: this.contactData.loadingDefaultDelay });
        }
        this.darkModeEnabled = this.darkModeService.isEnabled ? true : false;
        this.phase3 = this.contactData ? this.contactData.enableHelpAndContactPhase3 : false;
        this.phase2 = this.contactData ? this.contactData.enableHelpAndContactPhase2 : false;
        if (this.contactData && this.contactData.csMessage && this.contactData.csMessage.text) {
            this.message = this.phase3 ? null : this.contactData.csMessage.text;
        }
        if (this.phase3) {
            const position: string =
                this.HccCategory !== '' && this.HccArticle != ''
                    ? 'Help & Contact' + '/' + this.HccCategory + '/' + this.HccArticle + '/contact Us'
                    : 'Help & Contact/contact Us';
            this.contactOptionClickEventTracking(
                'load',
                position,
                'contact us options page',
                'contact us options page',
                this.windowRef.nativeWindow.location.href,
                'not applicable',
                this.HccArticle != ''
                    ? this.HccArticle
                    : this.navigationService.location.search.get('Article')
                      ? this.navigationService.location.search.get('Article')
                      : 'not applicable',
                this.HccCategory !== ''
                    ? this.HccCategory
                    : this.navigationService.location.search.get('Category')
                      ? this.navigationService.location.search.get('Category')
                      : 'not applicable',
            );
        }
        this.isNative = this.nativeApplicationService.isNativeApp;
        this.navigationSource = this.navigationService.location.search.get('source') || '';
        this.facebookLink = this.getLinkByKey(this.contactData.contactPageLinkButtons, 'facebook');
        this.pqrsLink = this.getLinkByKey(this.contactData.contactPageLinkButtons, 'pqrs');
        this.instagram = this.getLinkByKey(this.contactData.contactPageLinkButtons, 'instagram');
        this.newAccountMenuService.scrollToTop();
        this.zendeskChatEnabled = this.zendeskClientConfig.enabled;
        this.isMobile = this.mediaQueryService.isActive('lt-sm');
        this.isXsDevice = this.mediaQueryService.isActive('xs');
        this.isGtXsDevice = this.mediaQueryService.isActive('gt-xs');

        this.portalMediaQueryService.mediaQuery.subscribe(() => {
            this.isXsDevice = this.mediaQueryService.isActive('xs');
            this.isGtXsDevice = this.mediaQueryService.isActive('gt-xs');
        });
        if (
            this.contactData.helpAndContactUxCleanUpEnabled &&
            this.contactData.csMessage !== null &&
            this.contactData.csMessage !== undefined &&
            !this.isNullOrUndefined(this.contactData.csMessage.text)
        ) {
            this.messageQueue.clear();
            this.messageQueue.add(this.contactData.csMessage.text, MessageType.Information, MessageLifetime.Single);
        }
        this.v2NavEnabled = this.newAccountMenuService.isNewAccountMenu() && !this.newAccountMenuService.isEpcotMenuEnabled();
        this.isLoggedIn = this.user.isAuthenticated;
        this.v2NavEnabledPreLogin = (this.v2NavEnabled && !this.isLoggedIn) || !this.v2NavEnabled;
        this.contactResourceService.getContactOptionsContent().subscribe((data: any) => {
            this.commonMethodService.hideLoader();
            if (document.getElementById('hcc-skeleton-contact')) document.getElementById('hcc-skeleton-contact')!.remove();
            this.contactOptionsData = data.content;
            this.allowedCPKeywords = data.allowedCPKeywords;
            this.enableCORPhoneNumbers = data.enableCORPhoneNumbers;
            this.deepLinkingEnabled = this.isKeywordAvailable() ?? false;
            this.helpAndContactData.showButtons = true;
            this.recommenededOptions = data.recommenededOptions;
            this.sitecoreControlForOptionsEnabled = data.enableSitecoreControlForOptions;
            let contactOptions: any;
            this.isPhoneDependentOnAgent = data.isPhoneDependentOnAgent;
            if (this.navigationSource && this.navigationSource != '' && this.contactData.showContactOptionsBySource[this.navigationSource]) {
                contactOptions = this.contactData.showContactOptionsBySource[this.navigationSource];
                this.contactData.showDocumentUploadOption = false;
                this.isCustomSource = true;
            } else {
                if (this.contactData.enableHelpAndContactPhase2) {
                    contactOptions = data.contactOptionsPhase2[this.contactData.playerPriority.toLowerCase()];
                } else {
                    contactOptions = this.contactData.isVipUser
                        ? this.contactData.contactOptions.vip_user
                        : this.contactData.contactOptions.standard_user;
                    this.showCustomerServiceMessage();
                }
            }
            if (this.zendeskClientConfig.removeLiveChat) {
                const finalOptions: { [key: number]: any } = {};
                let k: number = 1;
                for (let i: number = 1; i <= Object.keys(contactOptions).length; i++) {
                    const option = contactOptions[i].toUpperCase();
                    if (option != 'CHAT') {
                        finalOptions[k] = contactOptions[i];
                        k++;
                    }
                }
                contactOptions = finalOptions;
            }
            this.noOfContactOptions = Object.keys(contactOptions).length;
            this.SortOptions(contactOptions);
            let optionsArray: any[];
            optionsArray = Object.values(contactOptions);
            optionsArray.map((individualoption: any) => {
                const option = individualoption;
                this.contactOptionClickEventTracking(
                    'load',
                    option,
                    'contact us options page',
                    'contact us method',
                    'not applicable',
                    optionsArray.indexOf(individualoption),
                    this.HccArticle != ''
                        ? this.HccArticle
                        : this.navigationService.location.search.get('Article')
                          ? this.navigationService.location.search.get('Article')
                          : 'not applicable',
                    this.HccCategory !== ''
                        ? this.HccCategory
                        : this.navigationService.location.search.get('Category')
                          ? this.navigationService.location.search.get('Category')
                          : 'not applicable',
                );
            });

            if (this.contactData.showDocumentUploadOption) {
                this.captureEventTracking('Help_Contact_HP_ContactOptions_UploadDoc_Active');
                this.contactOptionClickEventTracking(
                    'load',
                    'upload now',
                    'contact us options page',
                    'upload your documents',
                    'not applicable',
                    'not applicable',
                    this.HccArticle != ''
                        ? this.HccArticle
                        : this.navigationService.location.search.get('Article')
                          ? this.navigationService.location.search.get('Article')
                          : 'not applicable',
                    this.HccCategory !== ''
                        ? this.HccCategory
                        : this.navigationService.location.search.get('Category')
                          ? this.navigationService.location.search.get('Category')
                          : 'not applicable',
                );
            }
            const uploadOption = data.content.children.docupload.children;
            this.uploadDocumentName = uploadOption[Object.keys(uploadOption)[0]].name;
            this.uploadDocumentContent = uploadOption[Object.keys(uploadOption)[0]].title;
            this.uploadDocumentTooltip = uploadOption[Object.keys(uploadOption)[0]].text;
            this.uploadDocumentLink = uploadOption[Object.keys(uploadOption)[0]].parameters.url;
            if (this.contactData.enableHelpAndContactPhase2) {
                this.bannerTextPhase2 = this.contactOptionsData.messages[this.contactData.playerPriority.toLowerCase() + 'bannertext'];
                if (
                    this.contactData.csMessage !== undefined &&
                    this.contactData.csMessage !== null &&
                    !this.isNullOrUndefined(this.contactData.csMessage.text)
                ) {
                    this.captureEventTracking('Help_Contact_HP_ContactOptions_CSMessage');
                } else {
                    this.captureEventTracking('Help_Contact_HP_ContactOptions');
                }
            }
            this.setfooter();
            const type = this.navigationService?.location?.search?.get('type')?.toUpperCase();
            if (type) this.goTo(type);
        });
        if (this.navigationService.location.search.get('source') && this.navigationService.location.search.get('source') == 'complaintform') {
            if (this.contactData.isLoadingIndicatorEnabled && this.contactData.enableHelpAndContactPhase3) {
                this.loadingIndicationDisabled = true;
                this.loadingIndicatorHandler.done();
            }
            this.goTo('EMAIL');
            this.tracking.triggerEvent('Event.Tracking', {
                'component.CategoryEvent': 'Help Center',
                'component.LabelEvent': 'Help options',
                'component.ActionEvent': 'Load',
                'component.PositionEvent': 'not applicable',
                'component.LocationEvent': 'not applicable',
                'component.EventDetails': 'Official Complaint Form',
                'component.URLClicked': 'not applicable',
            });
        }
        if (this.contactData.enableChatHistory && this.contactData.chatHistoryContent && this.contactData.chatHistory != null) {
            const chatStatus = JSON.parse(this.contactData.chatHistory.toString())[this.contactData.playerPriority?.toLowerCase()];
            chatStatus && chatStatus.toLowerCase() == 'on' && this.newAccountMenuService.getMenuVersion() != 1
                ? (this.showchathistory = true)
                : (this.showchathistory = false);
            this.tracking.triggerEvent('Event.HCC', {
                'component.CategoryEvent': 'hcc',
                'component.LabelEvent': 'chat history',
                'component.ActionEvent': 'load',
                'component.PositionEvent': 'suggestions',
                'component.LocationEvent': 'contact us options page',
                'component.EventDetails': 'chat history option',
                'component.URLClicked': 'not applicable',
                'component.hccCategory': 'not applicable',
                'component.hccArticle': 'not applicable',
            });
        }
    }

    get isAvailable$(): Observable<boolean> {
        if (this.zendeskChatEnabled) {
            const isEnabled = this.zendeskClientConfig.sunshineConfig.isZendeskAvailable == 'True' ? true : false;
            return new Observable((observer) => {
                observer.next(isEnabled);
            });
        } else {
            return of(false);
        }
    }
    showCustomerServiceMessage(): void {
        if (this.contactData.isVipUser) {
            if (this.contactData.showCustomerServiceMessage.vipUser) {
                if (!this.isNullOrUndefined(this.contactOptionsData.messages.VipCSMTitle)) this.csMsg = this.contactOptionsData.messages.VipCSMTitle;
                if (!this.isNullOrUndefined(this.contactOptionsData.messages.VipCSMBody)) {
                    if (this.isNullOrUndefined(this.csMsg)) this.csMsg = this.contactOptionsData.messages.VipCSMBody;
                    else this.csMsg += this.contactOptionsData.messages.VipCSMBody;
                }
                if (!this.isNullOrUndefined(this.contactOptionsData.messages.VipCSMLink)) {
                    this.csLink = this.contactOptionsData.messages.VipCSMLink;
                }
            }
        } else {
            if (this.contactData.showCustomerServiceMessage.standardUser) {
                if (!this.isNullOrUndefined(this.contactOptionsData.messages.NonVipCSMTitle))
                    this.csMsg = this.contactOptionsData.messages.NonVipCSMTitle;
                if (!this.isNullOrUndefined(this.contactOptionsData.messages.NonVipCSMBody)) {
                    if (this.isNullOrUndefined(this.csMsg)) this.csMsg = this.contactOptionsData.messages.NonVipCSMBody;
                    else this.csMsg += this.contactOptionsData.messages.NonVipCSMBody;
                }
                if (!this.isNullOrUndefined(this.contactOptionsData.messages.NonVipCSMLink)) {
                    this.csLink = this.contactOptionsData.messages.NonVipCSMLink;
                }
            }
        }
        if (!this.isNullOrUndefined(this.csMsg)) {
            this.capturePageLoadTracking('Help_Contact_ContactOptions_CustomerService');
        }
    }

    checkStatusInSitecore() {
        const priority = this.contactData.playerPriority?.toLowerCase();
        let checkSetting: boolean = false;

        if (!this.isNullOrEmpty(this.currentSelectedSubCategory) && !this.isNullOrEmpty(this.currentSelectedSubCategory.value)) {
            checkSetting = true;
        }

        if (checkSetting) {
            if (!this.isNullOrUndefined(this.currentSelectedSubCategory.value.liveChat)) {
                const chatStatus = JSON.parse(this.currentSelectedSubCategory.value.liveChat)[priority];
                if (chatStatus && chatStatus.toUpperCase() == 'ON' && this.optionAlreadyUpdated['CHAT'] == false) {
                    this.isAvailable$.subscribe((data: any) => {
                        if (data) this.liveChatenabled = true;
                        else this.liveChatenabled = false;
                        this.contactData.enableHelpAndContactPhase2 ? this.buildFormPhase2('CHAT') : this.buildForm('CHAT');
                    });
                }
            }

            if (!this.isNullOrUndefined(this.currentSelectedSubCategory.value.phone)) {
                const phoneStatus = JSON.parse(this.currentSelectedSubCategory.value.phone)[priority];
                if (phoneStatus && phoneStatus.toUpperCase() == 'ON' && this.optionAlreadyUpdated['PHONE'] == false) {
                    this.isAvailable$.subscribe((data: any) => {
                        if (data) this.liveChatenabled = true;
                        else this.liveChatenabled = false;
                        this.contactData.enableHelpAndContactPhase2 ? this.buildFormPhase2('PHONE') : this.buildForm('PHONE');
                    });
                }
            }

            if (!this.isNullOrUndefined(this.currentSelectedSubCategory.value.email)) {
                const emailStatus = JSON.parse(this.currentSelectedSubCategory.value.email)[priority];
                if (emailStatus && emailStatus.toUpperCase() == 'ON' && this.optionAlreadyUpdated['EMAIL'] == false)
                    this.contactData.enableHelpAndContactPhase2 ? this.buildFormPhase2('EMAIL') : this.buildForm('EMAIL');
            }

            if (!this.isNullOrUndefined(this.currentSelectedSubCategory.value.faq)) {
                const faqStatus = JSON.parse(this.currentSelectedSubCategory.value.faq)[priority];
                if (faqStatus && faqStatus.toUpperCase() == 'ON' && this.optionAlreadyUpdated['FAQ'] == false)
                    this.contactData.enableHelpAndContactPhase2 ? this.buildFormPhase2('FAQ') : this.buildForm('FAQ');
            }

            if (!this.isNullOrUndefined(this.currentSelectedSubCategory.value.twitter)) {
                const twitterStatus = JSON.parse(this.currentSelectedSubCategory.value.twitter)[priority];
                if (twitterStatus && twitterStatus.toUpperCase() == 'ON' && this.optionAlreadyUpdated['TWITTER'] == false)
                    this.contactData.enableHelpAndContactPhase2 ? this.buildFormPhase2('TWITTER') : this.buildForm('TWITTER');
            }
            if (!this.isNullOrUndefined(this.currentSelectedSubCategory.value.facebook)) {
                const facebookStatus = JSON.parse(this.currentSelectedSubCategory.value.facebook)[priority];
                if (facebookStatus && facebookStatus.toUpperCase() == 'ON' && this.optionAlreadyUpdated['FACEBOOK'] == false)
                    this.contactData.enableHelpAndContactPhase2 ? this.buildFormPhase2('FACEBOOK') : this.buildForm('FACEBOOK');
            }
            if (!this.isNullOrUndefined(this.currentSelectedSubCategory.value.pqrs) && this.claimsService.get('country') == 'CO') {
                const pqrsStatus = JSON.parse(this.currentSelectedSubCategory.value.pqrs)[priority];
                if (pqrsStatus && pqrsStatus.toUpperCase() == 'ON' && this.optionAlreadyUpdated['PQRS'] == false)
                    this.contactData.enableHelpAndContactPhase2 ? this.buildFormPhase2('PQRS') : this.buildForm('PQRS');
            }
            if (!this.isNullOrUndefined(this.currentSelectedSubCategory.value.instagram)) {
                const instagramStatus = JSON.parse(this.currentSelectedSubCategory.value.instagram)[priority];
                if (instagramStatus && instagramStatus.toUpperCase() == 'ON' && this.optionAlreadyUpdated['INSTAGRAM'] == false)
                    this.contactData.enableHelpAndContactPhase2 ? this.buildFormPhase2('INSTAGRAM') : this.buildForm('INSTAGRAM');
            }
        }
    }

    SortOptions(options: any): void {
        let optionsArray: any[];
        optionsArray = Object.values(options);
        this.capturePageLoadTracking('Help_Contact_HP_ContactOptions');
        optionsArray.map((individualoption: any) => {
            const option = individualoption.toUpperCase();
            if (option === 'PHONE') {
                this.isAvailable$.subscribe((data: any) => {
                    if (data) {
                        this.liveChatenabled = true;
                    } else {
                        this.liveChatenabled = false;
                    }
                    this.contactData.enableHelpAndContactPhase2 ? this.buildFormPhase2('PHONE') : this.buildForm('PHONE');
                });
            }
            if (option === 'CHAT') {
                this.isAvailable$.subscribe((data: any) => {
                    if (data) {
                        this.liveChatenabled = true;
                    } else {
                        this.liveChatenabled = false;
                    }
                    this.contactData.enableHelpAndContactPhase2 ? this.buildFormPhase2('CHAT') : this.buildForm('CHAT');
                });
            }
            this.contactData.enableHelpAndContactPhase2 ? this.buildFormPhase2(option) : this.buildForm(option);
        });
        if (this.sitecoreControlForOptionsEnabled) this.checkStatusInSitecore();
    }

    buildFormPhase2(option: string): void {
        this.optionAlreadyUpdated[option] = true;
        option = option.toUpperCase();
        let checkSetting: boolean = false;
        if (!this.isNullOrEmpty(this.currentSelectedSubCategory) && !this.isNullOrEmpty(this.currentSelectedSubCategory.value)) {
            checkSetting = true;
        }
        switch (option) {
            case 'CHAT':
                let showChat: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.liveChat)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.liveChat)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showChat = false;
                    }
                }
                if (showChat && this.contactOptionsData.children!.chat) {
                    const object: contactOptionObject = new contactOptionObject();
                    object.key = option;
                    const contactOption = this.isCPCCUser ? this.contactOptionsData.children.chat_cp : this.contactOptionsData.children.chat;
                    contactOption.isEnabled = this.liveChatenabled;
                    object.value = contactOption;
                    if (this.liveChatenabled) {
                        if (!this.livechatWaTrigger) {
                            this.captureEventTracking('Help_Contact_HP_ContactOptions_LiveChat_Active');
                            this.livechatWaTrigger = true;
                        }
                        let index = this.disabledContactOptions.map((o) => o.key).indexOf('CHAT');
                        if (index > -1) {
                            this.disabledContactOptions.splice(index, 1);
                        }
                        index = this.enabledContactOptions.map((o) => o.key).indexOf('CHAT');
                        if (index === -1) {
                            this.enabledContactOptions.push(object);
                        }
                    } else {
                        if (!this.livechatWaTrigger) {
                            this.captureEventTracking('Help_Contact_HP_ContactOptions_LiveChat_Inactive');
                            this.livechatWaTrigger = true;
                        }
                        let index = this.enabledContactOptions.map((o) => o.key).indexOf('CHAT');
                        if (index > -1) {
                            this.enabledContactOptions.splice(index, 1);
                        }
                        index = this.disabledContactOptions.map((o) => o.key).indexOf('CHAT');
                        if (index === -1) {
                            this.disabledContactOptions.push(object);
                        }
                    }
                }
                break;
            case 'PHONE':
                let showPhone: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.phone)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.phone)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showPhone = false;
                    }
                }
                if (showPhone && this.contactOptionsData.children!.phone) {
                    const object1: contactOptionObject = new contactOptionObject();
                    object1.key = option;
                    const contactOption1 = this.contactOptionsData.children!.phone;
                    contactOption1.isEnabled = this.liveChatenabled;
                    contactOption1.text = this.isPhoneAvailableForCOR
                        ? this.TextBasedOnCOR
                        : this.deepLinkingEnabled
                          ? this.getKeyWordContent().text
                          : this.contactOptionsData.children.phone.text;
                    object1.value = contactOption1;
                    const phoneNumbers = Object.values(contactOption1.children);
                    if (this.phoneList.length < 1) {
                        phoneNumbers.map((phoneNumber: any) => {
                            this.phoneList.push(phoneNumber);
                        });
                        if (this.deepLinkingEnabled || this.isPhoneAvailableForCOR) {
                            const deeplinkingPhoneNumber = {
                                title: this.isPhoneAvailableForCOR ? this.isPhoneAvailableForCOR : this.getKeyWordContent().title,
                                text: this.getKeyWordContent().messages.titleText,
                            };
                            this.phoneList.splice(0, 1);
                            this.phoneList.splice(0, 0, deeplinkingPhoneNumber);
                        }
                    }
                    if ((this.isPhoneDependentOnAgent && this.liveChatenabled) || !this.isPhoneDependentOnAgent) {
                        let index = this.disabledContactOptions.map((o) => o.key).indexOf('PHONE');
                        if (index > -1) {
                            this.disabledContactOptions.splice(index, 1);
                        }
                        if (!this.phoneWaTrigger) {
                            this.captureEventTracking('Help_Contact_HP_ContactOptions_Phone_Active');
                            this.phoneWaTrigger = true;
                        }
                        index = this.enabledContactOptions.map((o) => o.key).indexOf('PHONE');
                        if (index === -1) {
                            this.enabledContactOptions.push(object1);
                        }
                    } else {
                        if (!this.phoneWaTrigger) {
                            this.captureEventTracking('Help_Contact_HP_ContactOptions_Phone_Inactive');
                            this.phoneWaTrigger = true;
                        }
                        let index = this.enabledContactOptions.map((o) => o.key).indexOf('PHONE');
                        if (index > -1) {
                            this.enabledContactOptions.splice(index, 1);
                        }
                        index = this.disabledContactOptions.map((o) => o.key).indexOf('PHONE');
                        if (index === -1) {
                            this.disabledContactOptions.push(object1);
                        }
                    }
                }
                break;
            case 'EMAIL':
                let showEmail: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.email)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.email)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showEmail = false;
                    }
                }
                if (showEmail && this.contactOptionsData.children!.email) {
                    const object2: contactOptionObject = new contactOptionObject();
                    object2.key = option;
                    const contactOption2 = this.contactOptionsData.children.email;
                    contactOption2.isEnabled = this.contactData.isEmailOptionActive;
                    object2.value = contactOption2;
                    if (contactOption2.isEnabled) {
                        this.captureEventTracking('Help_Contact_HP_ContactOptions_Email_Active');
                        this.enabledContactOptions.push(object2);
                    } else {
                        this.captureEventTracking('Help_Contact_HP_ContactOptions_Email_Inactive');
                        this.disabledContactOptions.push(object2);
                    }
                }
                break;
            case 'FAQ':
                let showFAQ: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.faq)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.faq)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showFAQ = false;
                    }
                }
                if (this.navigatedFromMohInterceptor() && this.nativeApplicationService.isNativeApp) {
                    showFAQ = false;
                }
                if (showFAQ && this.contactOptionsData.children!.faq) {
                    const object3: contactOptionObject = new contactOptionObject();
                    object3.key = option;
                    const contactOption3 = this.contactOptionsData.children.faq;
                    contactOption3.isEnabled = this.contactData.isFaqOptionActive;
                    object3.value = contactOption3;
                    if (contactOption3.isEnabled) {
                        this.captureEventTracking('Help_Contact_HP_ContactOptions_FAQs_Active');
                        this.enabledContactOptions.push(object3);
                    } else {
                        this.captureEventTracking('Help_Contact_HP_ContactOptions_FAQs_Inactive');
                        this.disabledContactOptions.push(object3);
                    }
                }
                break;
            case 'TWITTER':
                let showTwitter: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.twitter)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.twitter)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showTwitter = false;
                    }
                }
                if (this.navigatedFromMohInterceptor() && this.nativeApplicationService.isNativeApp) {
                    showTwitter = false;
                }
                if (showTwitter && this.contactOptionsData.children!.twitter && !this.deepLinkingEnabled) {
                    const object4: contactOptionObject = new contactOptionObject();
                    object4.key = option;
                    const contactOption4 = this.contactOptionsData.children.twitter;
                    contactOption4.isEnabled = this.contactData.isTwitterOptionActive;
                    this.nativeTwitterLink = this.twitterLink.linkItems['url'];
                    object4.value = contactOption4;
                    if (contactOption4.isEnabled) {
                        this.enabledContactOptions.push(object4);
                    } else {
                        this.disabledContactOptions.push(object4);
                    }
                }
                break;
            case 'INSTAGRAM':
                let showInstagarm: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.instagram)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.instagram)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showInstagarm = false;
                    }
                }
                if (this.navigatedFromMohInterceptor() && this.nativeApplicationService.isNativeApp) {
                    showInstagarm = false;
                }
                if (showInstagarm && this.contactOptionsData.children!.instagram && !this.deepLinkingEnabled) {
                    const object4: contactOptionObject = new contactOptionObject();
                    object4.key = option;
                    const contactOption4 = this.contactOptionsData.children.instagram;
                    contactOption4.isEnabled = this.contactData.isInstagramOptionActive;
                    object4.value = contactOption4;
                    this.nativeInstagramLink = this.instagram!.linkItems['url'];
                    if (contactOption4.isEnabled) {
                        this.enabledContactOptions.push(object4);
                    } else {
                        this.disabledContactOptions.push(object4);
                    }
                }
                break;
            case 'FACEBOOK':
                let showFacebook: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.facebook)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.facebook)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showFacebook = false;
                    }
                }
                if (this.navigatedFromMohInterceptor() && this.nativeApplicationService.isNativeApp) {
                    showFacebook = false;
                }
                if (showFacebook && this.contactOptionsData.children!.facebook && !this.deepLinkingEnabled) {
                    const object4: contactOptionObject = new contactOptionObject();
                    object4.key = option;
                    const contactOption4 = this.contactOptionsData.children.facebook;
                    contactOption4.isEnabled = this.contactData.isFaceBookOptionActive;
                    this.nativeFaceBookLink = this.facebookLink!.linkItems['url'];
                    object4.value = contactOption4;
                    if (contactOption4.isEnabled) {
                        this.enabledContactOptions.push(object4);
                    } else {
                        this.disabledContactOptions.push(object4);
                    }
                }
                break;
            case 'PQRS':
                let showPqrs: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.pqrs)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.pqrs)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showPqrs = false;
                    }
                }
                if (this.navigatedFromMohInterceptor() && this.nativeApplicationService.isNativeApp) {
                    showPqrs = false;
                }
                if (showPqrs && this.contactOptionsData.children!.pqrs && !this.deepLinkingEnabled) {
                    const object4: contactOptionObject = new contactOptionObject();
                    object4.key = option;
                    const contactOption4 = this.contactOptionsData.children.pqrs;
                    contactOption4.isEnabled = this.contactData.isPQRSOptionActive;
                    object4.value = contactOption4;
                    if (contactOption4.isEnabled) {
                        this.enabledContactOptions.push(object4);
                    } else {
                        this.disabledContactOptions.push(object4);
                    }
                }
                break;
        }
    }

    isKeywordAvailable() {
        return (
            this.activatedRoute.snapshot.queryParamMap.get('showContact') == 'true' &&
            this.getKeyword() &&
            this.allowedCPKeywords.includes(this.getKeyword()!) &&
            this.getKeyWordContent()
        );
    }

    getKeyword() {
        return this.activatedRoute.snapshot.queryParamMap.get('keyword')?.toLowerCase();
    }

    getKeyWordContent() {
        return this.contactOptionsData.children!['phone_' + this.getKeyword()];
    }

    get isCPCCUser() {
        return this.deepLinkingEnabled && this.getKeyword() == 'customerprotectionint';
    }

    get TextBasedOnCOR() {
        return this.isPhoneAvailableForCOR + this.contactOptionsData.children!['phone_cor']?.text;
    }

    get isPhoneAvailableForCOR() {
        return (
            this.getKeyword() &&
            this.enableCORPhoneNumbers.indexOf(this.getKeyword()!) > -1 &&
            this.contactOptionsData.children!['phone_cor']?.messages['MobileNumber_' + this.user.country]
        );
    }

    buildForm(option: string): void {
        option = option.toUpperCase();
        let checkSetting: boolean = false;
        if (!this.isNullOrEmpty(this.currentSelectedSubCategory) && !this.isNullOrEmpty(this.currentSelectedSubCategory.value)) {
            checkSetting = true;
        }
        switch (option) {
            case 'CHAT':
                const object: contactOptionObject = new contactOptionObject();
                object.key = option;
                const contactOption = this.contactOptionsData.children.chat;
                contactOption.isEnabled = this.liveChatenabled;
                object.value = contactOption;
                if (this.isLoggedIn) {
                    if (this.liveChatenabled) {
                        if (!this.livechatWaTrigger) {
                            this.captureEventTracking('Help_Contact_HP_ContactOptions_LiveChat_Active');
                            this.livechatWaTrigger = true;
                        }
                        let index = this.disabledContactOptions.map((o) => o.key).indexOf('CHAT');
                        if (index > -1) {
                            this.disabledContactOptions.splice(index, 1);
                        }
                        index = this.enabledContactOptions.map((o) => o.key).indexOf('CHAT');
                        if (index === -1) {
                            this.enabledContactOptions.push(object);
                        }
                    } else {
                        if (!this.livechatWaTrigger) {
                            this.captureEventTracking('Help_Contact_HP_ContactOptions_LiveChat_Inactive');
                            this.livechatWaTrigger = true;
                        }
                        let index = this.enabledContactOptions.map((o) => o.key).indexOf('CHAT');
                        if (index > -1) {
                            this.enabledContactOptions.splice(index, 1);
                        }
                        index = this.disabledContactOptions.map((o) => o.key).indexOf('CHAT');
                        if (index === -1) {
                            this.disabledContactOptions.push(object);
                        }
                    }
                }
                break;
            case 'PHONE':
                const object1: contactOptionObject = new contactOptionObject();
                object1.key = option;
                if (this.phoneList.length < 1) {
                    const contactOption1 = this.contactOptionsData.children.phone;
                    contactOption1.isEnabled = this.liveChatenabled;
                    contactOption1.text = this.isPhoneAvailableForCOR
                        ? this.TextBasedOnCOR
                        : this.deepLinkingEnabled
                          ? this.getKeyWordContent().text
                          : this.contactOptionsData.children.phone.text;
                    object1.value = contactOption1;
                    const phoneNumbers = Object.keys(contactOption1.children);
                    phoneNumbers.map((phoneNumber: any) => {
                        this.phoneList.push(phoneNumber);
                    });
                }
                if (this.liveChatenabled) {
                    let index = this.disabledContactOptions.map((o) => o.key).indexOf('PHONE');
                    if (index > -1) {
                        this.disabledContactOptions.splice(index, 1);
                    }
                    if (!this.phoneWaTrigger) {
                        this.captureEventTracking('Help_Contact_HP_ContactOptions_Phone_Active');
                        this.phoneWaTrigger = true;
                    }
                    index = this.enabledContactOptions.map((o) => o.key).indexOf('PHONE');
                    if (index === -1) {
                        this.enabledContactOptions.push(object1);
                    }
                } else {
                    if (!this.phoneWaTrigger) {
                        this.captureEventTracking('Help_Contact_HP_ContactOptions_Phone_Inactive');
                        this.phoneWaTrigger = true;
                    }
                    let index = this.enabledContactOptions.map((o) => o.key).indexOf('PHONE');
                    if (index > -1) {
                        this.enabledContactOptions.splice(index, 1);
                    }
                    index = this.disabledContactOptions.map((o) => o.key).indexOf('PHONE');
                    if (index === -1) {
                        this.disabledContactOptions.push(object1);
                    }
                }
                break;
            case 'EMAIL':
                const object2: contactOptionObject = new contactOptionObject();
                object2.key = option;
                const contactOption2 = this.contactOptionsData.children.email;
                contactOption2.isEnabled = this.contactData.isEmailOptionActive;
                object2.value = contactOption2;
                if (contactOption2.isEnabled) {
                    this.captureEventTracking('Help_Contact_HP_ContactOptions_Email_Active');
                    this.enabledContactOptions.push(object2);
                } else {
                    this.captureEventTracking('Help_Contact_HP_ContactOptions_Email_Inactive');
                    this.disabledContactOptions.push(object2);
                }
                break;
            case 'FAQ':
                const object3: contactOptionObject = new contactOptionObject();
                object3.key = option;
                const contactOption3 = this.contactOptionsData.children.faq;
                contactOption3.isEnabled = this.contactData.isFaqOptionActive;
                object3.value = contactOption3;
                if (contactOption3.isEnabled) {
                    this.captureEventTracking('Help_Contact_HP_ContactOptions_FAQs_Active');
                    this.enabledContactOptions.push(object3);
                } else {
                    this.captureEventTracking('Help_Contact_HP_ContactOptions_FAQs_Inactive');
                    this.disabledContactOptions.push(object3);
                }
                break;
            case 'TWITTER':
                let showTwitter: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.twitter)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.twitter)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showTwitter = false;
                    }
                }
                if (this.navigatedFromMohInterceptor() && this.nativeApplicationService.isNativeApp) {
                    showTwitter = false;
                }
                if (showTwitter && this.contactOptionsData.children!.twitter && !this.deepLinkingEnabled) {
                    const object4: contactOptionObject = new contactOptionObject();
                    object4.key = option;
                    const contactOption4 = this.contactOptionsData.children.twitter;
                    contactOption4.isEnabled = this.contactData.isTwitterOptionActive;
                    object4.value = contactOption4;
                    if (contactOption4.isEnabled) {
                        this.enabledContactOptions.push(object4);
                    } else {
                        this.disabledContactOptions.push(object4);
                    }
                }
                break;
            case 'INSTAGRAM':
                let showInstagarm: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.instagram)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.instagram)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showInstagarm = false;
                    }
                }
                if (this.navigatedFromMohInterceptor() && this.nativeApplicationService.isNativeApp) {
                    showInstagarm = false;
                }
                if (showInstagarm && this.contactOptionsData.children!.instagram && !this.deepLinkingEnabled) {
                    const object4: contactOptionObject = new contactOptionObject();
                    object4.key = option;
                    const contactOption4 = this.contactOptionsData.children.instagram;
                    contactOption4.isEnabled = this.contactData.isInstagramOptionActive;
                    object4.value = contactOption4;
                    if (contactOption4.isEnabled) {
                        this.enabledContactOptions.push(object4);
                    } else {
                        this.disabledContactOptions.push(object4);
                    }
                }
                break;
            case 'FACEBOOK':
                let showFacebook: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.facebook)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.facebook)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showFacebook = false;
                    }
                }
                if (this.navigatedFromMohInterceptor() && this.nativeApplicationService.isNativeApp) {
                    showFacebook = false;
                }
                if (showFacebook && this.contactOptionsData.children!.facebook && !this.deepLinkingEnabled) {
                    const object4: contactOptionObject = new contactOptionObject();
                    object4.key = option;
                    const contactOption4 = this.contactOptionsData.children.facebook;
                    contactOption4.isEnabled = this.contactData.isFaceBookOptionActive;
                    object4.value = contactOption4;
                    if (contactOption4.isEnabled) {
                        this.enabledContactOptions.push(object4);
                    } else {
                        this.disabledContactOptions.push(object4);
                    }
                }
                break;
            case 'PQRS':
                let showPqrs: boolean = true;
                if (checkSetting && !this.isNullOrUndefined(this.currentSelectedSubCategory.value.pqrs)) {
                    const value = JSON.parse(this.currentSelectedSubCategory.value.pqrs)[this.contactData.playerPriority.toLowerCase()];
                    if (value.toUpperCase() === 'OFF') {
                        showPqrs = false;
                    }
                }
                if (this.navigatedFromMohInterceptor() && this.nativeApplicationService.isNativeApp) {
                    showPqrs = false;
                }
                if (showPqrs && this.contactOptionsData.children!.pqrs && !this.deepLinkingEnabled) {
                    const object4: contactOptionObject = new contactOptionObject();
                    object4.key = option;
                    const contactOption4 = this.contactOptionsData.children.pqrs;
                    contactOption4.isEnabled = this.contactData.isPQRSOptionActive;
                    object4.value = contactOption4;
                    if (contactOption4.isEnabled) {
                        this.enabledContactOptions.push(object4);
                    } else {
                        this.disabledContactOptions.push(object4);
                    }
                }
                break;
        }
    }

    goTo(key: string, index: Number = 0): void {
        switch (key) {
            case 'EMAIL':
                this.goToEmail();
                this.contactOptionClickEventTracking(
                    'click',
                    'Email',
                    'contact us options page',
                    'contact us method',
                    'not applicable',
                    Number(index) + 1,
                    'not applicable',
                    'not applicable',
                );
                break;
            case 'CHAT':
                if (!this.isLoggedIn) {
                    this.captureEventTracking('Help_Contact_ContactOptions_LiveChat_NotLoggedIn_Clicked');
                } else {
                    this.captureEventTracking('Help_Contact_ContactOptions_LiveChat_LoggedIn_Clicked');
                }
                const _window = <any>this.windowRef.nativeWindow;
                if (_window.entainsprinklr && _window.sprChatSettings && !_window.sprChat?.loaded) _window.entainsprinklr.openChat();
                else if (this.zendeskChatEnabled && _window.gvczendesk) {
                    _window.gvczendesk.livechatclick();
                }
                this.contactOptionClickEventTracking(
                    'click',
                    'live chat',
                    'contact us options page',
                    'contact us method',
                    'not applicable',
                    Number(index) + 1,
                    'not applicable',
                    'not applicable',
                );
                break;
            case 'PHONE':
                this.goToPhone();
                let isRgclosed: boolean = false;
                if (this.navigationSource.toLowerCase() == 'rgclosed') isRgclosed = true;
                this.tracking.triggerEvent(isRgclosed ? 'Event.Tracking' : 'Event.HCC', {
                    'component.CategoryEvent': isRgclosed ? 'gambling controls' : 'hcc',
                    'component.LabelEvent': isRgclosed ? 'self exclusion error' : 'contact us',
                    'component.ActionEvent': 'click',
                    'component.PositionEvent': isRgclosed ? 'not applicable' : 'Phone',
                    'component.LocationEvent': isRgclosed ? 'login page' : 'contact us options page',
                    'component.EventDetails': isRgclosed ? key : 'contact us method',
                    'component.URLClicked': 'not applicable',
                    'component.ContentPosition': isRgclosed ? 'not applicable' : Number(index) + 1,
                    'component.hccArticle': 'not applicable',
                    'component.hccCategory': 'not applicable',
                });
                break;
            case 'FAQ':
                this.captureEventTracking('Help_Contact_ContactOptions_FAQs_Clicked');
                //this.navigation.goTo(this.faqLink.linkItems['url']);
                this.windowRef.nativeWindow.open(this.faqLink.linkItems['url']);
                break;
            case 'TWITTER':
                if (!this.isLoggedIn) {
                    this.captureEventTracking('Help_Contact_ContactOptions_Twitter_NotLoggedIn_Visitor_Twitter_Clicked');
                } else {
                    const playerPriority = this.contactData.playerPriority.toUpperCase();
                    this.captureEventTracking('Help_Contact_ContactOptions_Twitter_LoggedIn_' + playerPriority + '_Twitter_Clicked');
                }
                this.contactOptionClickEventTracking(
                    'click',
                    'Twitter',
                    'contact us options page',
                    'contact us method',
                    this.twitterLink.linkItems['url'],
                    Number(index) + 1,
                    'not applicable',
                    'not applicable',
                );
                if (this.isNative) return;
                this.windowRef.nativeWindow.open(this.twitterLink.linkItems['url']);
                break;
            case 'FACEBOOK':
                this.contactOptionClickEventTracking(
                    'click',
                    'Facebook',
                    'contact us options page',
                    'contact us method',
                    this.facebookLink!.linkItems['url'],
                    Number(index) + 1,
                    'not applicable',
                    'not applicable',
                );
                if (this.isNative) return;
                this.windowRef.nativeWindow.open(this.facebookLink!.linkItems['url']);
                break;
            case 'PQRS':
                this.windowRef.nativeWindow.open(this.pqrsLink!.linkItems['url']);
                break;
            case 'INSTAGRAM':
                this.contactOptionClickEventTracking(
                    'click',
                    'Instagram',
                    'contact us options page',
                    'contact us method',
                    this.instagram!.linkItems['url'],
                    Number(index) + 1,
                    'not applicable',
                    'not applicable',
                );
                if (this.isNative) return;
                this.windowRef.nativeWindow.open(this.instagram!.linkItems['url']);
                break;
        }
    }

    goToDocumentUpload() {
        const article =
            this.HccArticle != ''
                ? this.HccArticle
                : this.navigationService.location.search.get('Article')
                  ? this.navigationService.location.search.get('Article')
                  : 'not applicable';
        const category =
            this.HccCategory !== ''
                ? this.HccCategory
                : this.navigationService.location.search.get('Category')
                  ? this.navigationService.location.search.get('Category')
                  : 'not applicable';
        if (this.contactData.showNewDocumentUploadOption) {
            const trackingEvent: TrackingEvent = {
                CategoryEvent: 'hcc',
                LabelEvent: 'contact us',
                ActionEvent: 'click',
                PositionEvent: 'bottom of the page',
                LocationEvent: 'contact us',
                EventDetails: 'upload now cta',
                UrlClicked: this.windowRef.nativeWindow.location.href,
            };
            this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        }
        if (!this.isLoggedIn) {
            this.captureEventTracking('Help_Contact_ContactOptions_DocUpload_NotLoggedIn_Upload_Clicked');
            this.loginNavigationService.goToLogin({ appendReferrer: this.uploadDocumentLink });
            return;
        } else {
            if (this.uploadDocumentName === 'verifieduser') {
                this.captureEventTracking('KYC_Help_Contact_ContactOptions_LoggedIn_Verified_DocUpload_Click');
            }
            const uploadDocumnentquery = this.uploadDocumentLink + '&Article=' + article + '&Category=' + category;
            return this.navigationService.goTo(uploadDocumnentquery);
        }
    }
    goToEmail() {
        this.showEmail = true;
        this.onEmailSelected.emit(true);
        const dataToSend: any = {};
        dataToSend.contactData = this.contactData;
        dataToSend.selectedCategory = this.selectedCategory;
        dataToSend.showEmail = this.showEmail;
        dataToSend.helpAndContactData = this.helpAndContactData;
        dataToSend.optionsScreen = this.optionsScreen;
        dataToSend.contactOptionsData = this.contactOptionsData;
        dataToSend.isCPCCUser = this.isCPCCUser;
        this.onEmailScreenLoad.emit(dataToSend);
        this.helpAndContactData.showEmailScreen = true;
        this.helpAndContactData.showButtons = false;
    }

    goToPhone() {
        if (this.phoneList.length > 0) {
            this.captureEventTracking('Help_Contact_ContactOptions_Phone_MultipleNumbers_Clicked');
            this.showConfirmDialog(this.phoneList);
        } else {
            this.captureEventTracking('Help_Contact_ContactOptions_Phone_SingleNumber_Clicked');
            if (this.nativeApplicationService.isNativeWrapper || this.nativeApplicationService.isDownloadClient) {
                window.open('tel:' + this.contactOptionsData.children.phone.messages.singleNumberValue);
            } else {
                window.location.href = 'tel:' + this.contactOptionsData.children.phone.messages.singleNumberValue;
            }
        }
    }

    goToCsLink(): void {
        this.captureEventTracking('Help_Contact_ContactOptions_CustomerService_ReadMoreLink_Clicked');
    }

    protected showConfirmDialog(phoneList: any[]): MatDialogRef<any> {
        return this.dialog.open(PhoneOptionComponent, {
            data: {
                title: this.contactOptionsData.children.phone.messages.popupTitle,
                message: phoneList,
            },
        });
    }

    getContribution() {
        this.htmlNode.setCssClass('welcome-layer-visible', true);
        this.isPopupVisible = true;
    }
    closeContribution() {
        this.htmlNode.setCssClass('welcome-layer-visible', false);
        this.isPopupVisible = false;
    }

    liveChatClicked() {
        if (
            this.contactData.csMessage !== undefined &&
            this.contactData.csMessage !== null &&
            !this.isNullOrUndefined(this.contactData.csMessage.text)
        ) {
            this.captureEventTracking('Help_Contact_HP_LiveChat_CSMessage');
        } else {
            this.captureEventTracking('Help_Contact_HP_LiveChat');
        }
    }

    isNullOrEmpty(field: string): boolean {
        if (field !== undefined && field !== null) return false;
        return true;
    }

    isNullOrUndefined(str: string): boolean {
        if (str !== undefined && str !== null && str.length > 0) {
            return false;
        }
        return true;
    }
    ngAfterViewChecked() {
        if (
            this.contactData.isLoadingIndicatorEnabled &&
            this.contactData.enableHelpAndContactPhase3 &&
            (this.enabledContactOptions.length || this.disabledContactOptions.length) &&
            !this.loadingIndicationDisabled
        ) {
            this.loadingIndicationDisabled = true;
            this.loadingIndicatorHandler.done();
            this.changeDetectorRef.detectChanges();
        }
    }
    goToHistory() {
        this.tracking.triggerEvent('Event.HCC', {
            'component.CategoryEvent': 'hcc',
            'component.LabelEvent': 'chat history',
            'component.ActionEvent': 'click',
            'component.PositionEvent': 'suggestions',
            'component.LocationEvent': 'contact us options page',
            'component.EventDetails': 'chat history option',
            'component.URLClicked': 'not applicable',
            'component.hccCategory': 'not applicable',
            'component.hccArticle': 'not applicable',
        });
        this.portalNavigation.navigate('/chathistory');
    }
    private getLinkByKey(links: LinkTemplateItem[], key: string): LinkTemplateItem | null {
        const filteredLinks = links ? links.filter((l) => l.key === key) : null;
        return filteredLinks && filteredLinks.length ? filteredLinks[0] : null;
    }

    private setfooter() {
        let footerElement = document.getElementsByTagName('vn-footer')[0];
        if (footerElement == null) {
            footerElement = document.getElementsByTagName('vn-responsive-footer')[0];
        }
        if (footerElement) {
            footerElement.setAttribute('style', 'display:block;');
        }
    }

    private captureEventTracking(eventName: string) {
        this.tracking.triggerEvent('Event.Functionality.HelpContact', { 'page.referringAction': eventName });
    }

    private capturePageLoadTracking(eventName: string) {
        this.tracking.triggerEvent('pageView', { 'page.name': eventName });
    }
    private navigatedFromMohInterceptor() {
        return this.navigationService.location.search.has('source') && this.navigationService.location.search.get('source') === 'mohinterceptor';
    }
    public contactOptionClickEventTracking(
        actionEvent: string,
        positionEvent: string,
        locationEvent: string,
        eventDetails: string,
        urlClicked: any,
        contentPosition: any,
        hccArticle: any,
        hccCategory: any,
    ) {
        this.tracking.triggerEvent('Event.HCC', {
            'component.CategoryEvent': 'hcc',
            'component.LabelEvent': 'contact us',
            'component.ActionEvent': actionEvent,
            'component.PositionEvent': positionEvent,
            'component.LocationEvent': locationEvent,
            'component.EventDetails': eventDetails,
            'component.URLClicked': urlClicked,
            'component.ContentPosition': contentPosition,
            'component.hccArticle': hccArticle,
            'component.hccCategory': hccCategory,
        });
    }
}
